import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const ClipIcon = ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    {...restProps}
  >
    <path
      d="M9.17732 15C8.73009 15 9.11513 15 8.04185 15C5.53346 15 3.5 13.2091 3.5 11C3.5 8.79086 5.53346 7 8.04185 7H9.17732M13.7192 7H14.8546C17.363 7 19.3965 8.79086 19.3965 11C19.3965 13.2091 17.363 15 14.8546 15C13.8453 15 14.2238 15 13.7192 15"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`dark:${
        isActive
          ? "stroke-primary"
          : "stroke-caption group-hover:dark:stroke-primary"
      }`}
    />
    <path
      d="M14.8548 11H8.04199"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`dark:${
        isActive
          ? "stroke-primary"
          : "stroke-caption group-hover:dark:stroke-primary"
      }`}
    />
  </svg>
);

export default ClipIcon;
